<template>
  <balance
    :title="title"
    :cols="cols"
    :url="url"
    :showAccountFilters="false"
    :getAccountLedgerQuery="getAccountLedgerQuery"
  />
</template>

<script>
import Balance from "../Balance";

export default {
  name: "FloatAccountsBalanceByGroup",
  components: { Balance },
  props: {
    is_cost_center: {
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.setDocumentTitle('تراز حساب های شناور بر اساس گروه');
    },

    cols() {
      let text = "تفضیلی شناور";
      return {
        cols: [
          {
            text: "گروه " + text,
            value: "group_name",
            type: "text",
          },
          {
            text: text,
            value: "float_account_name",
            type: "text",
          },
        ],
      };
    },
    url() {
      return `reports/balance/floatsByGroup?`;
    },
  },
  methods: {
    getAccountLedgerQuery(item) {
      let query = {};
      if (item.group_name) {
        query["ledger.account"] = item.group_id;
        query["ledger.level"] = "floatAccountGroups";
      } else {
        query["ledger.account"] = item.float_account_id;
        query["ledger.level"] = "floatAccounts";
      }
      return query;
    },
  },
};
</script>
